export const buildUniversalOfficeTemplateTokens = ({
  primaryCustomerMobile,
  loanBankName,
  loanSanctionAmount,
  reasonNotTakingSbi,
  pendingAmount,
  formatAmount,
}: {
  primaryCustomerMobile?: string | null;
  loanBankName?: string | null;
  loanSanctionAmount?: number | null;
  reasonNotTakingSbi?: string | null;
  pendingAmount?: number | null;
  formatAmount: (value: number) => string;
}): Record<string, string> => ({
  '{{customer_mobile}}': String(primaryCustomerMobile || '').trim(),
  '{{loan_bank_name}}': String(loanBankName || '').trim(),
  '{{loan_sanction_amount}}': formatAmount(Number(loanSanctionAmount || 0) || 0),
  '{{reason_not_taking_sbi}}': String(reasonNotTakingSbi || '').trim(),
  '{{pending_amount}}': formatAmount(Math.max(0, Number(pendingAmount || 0) || 0)),
});
